import React from 'react';
import { Box, Container, Grid, Typography, Card, CardContent } from '@mui/material';
import {
  AttachMoney,
  SupportAgent,
  VerifiedUser,
  Speed,
  Language,
  School,
} from '@mui/icons-material';

const features = [
  {
    icon: <AttachMoney sx={{ fontSize: 40 }} />,
    title: 'Straight Talk on Costs',
    description: 'Transparent fee structure with no hidden charges. Get complete breakdown of tuition, hostel, and living expenses.',
  },
  {
    icon: <SupportAgent sx={{ fontSize: 40 }} />,
    title: 'End-to-End Support',
    description: 'From college selection to admission confirmation, visa processing, and post-arrival assistance.',
  },
  {
    icon: <VerifiedUser sx={{ fontSize: 40 }} />,
    title: 'NMC/MCI Approved',
    description: 'All our partner colleges are recognized by National Medical Commission and WHO listed.',
  },
  {
    icon: <Speed sx={{ fontSize: 40 }} />,
    title: 'Fast Processing',
    description: 'Quick admission processing with dedicated relationship manager for each student.',
  },
  {
    icon: <Language sx={{ fontSize: 40 }} />,
    title: 'Multiple Countries',
    description: 'Options available in India, Bangladesh, Nepal, Russia, China, Ukraine, and more.',
  },
  {
    icon: <School sx={{ fontSize: 40 }} />,
    title: 'FMGE Preparation',
    description: 'Comprehensive FMGE/NExT coaching and preparation support for students studying abroad.',
  },
];

const FeatureHighlights = () => {
  return (
    <Box sx={{ py: 8, bgcolor: 'white' }}>
      <Container maxWidth="xl">
        <Typography
          variant="h2"
          align="center"
          sx={{ mb: 2, fontSize: { xs: '1.8rem', md: '2.5rem' } }}
        >
          Why Choose{' '}
          <Box component="span" sx={{ color: 'secondary.main' }}>
            Learn Rabbit?
          </Box>
        </Typography>
        <Typography
          variant="h6"
          align="center"
          color="text.secondary"
          sx={{ mb: 6 }}
        >
          We provide comprehensive guidance for your medical education journey
        </Typography>

        <Grid container spacing={3}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: '100%',
                  textAlign: 'center',
                  transition: 'all 0.3s',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.12)',
                  },
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Box
                    sx={{
                      display: 'inline-flex',
                      p: 2,
                      borderRadius: '50%',
                      bgcolor: 'primary.main',
                      color: 'white',
                      mb: 3,
                    }}
                  >
                    {feature.icon}
                  </Box>
                  <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                    {feature.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default FeatureHighlights;